import { ToastType } from "../../Models/Common/toast-types-enum"
import { SHOW_INFO_TOAST, SHOW_ERROR_TOAST, SHOW_WARNING_TOAST } from "../types"

const initialState = {
  type: false,
  message: "",
  guid: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SHOW_INFO_TOAST:
      return {
        ...state,
        type: ToastType.INFO,
        message: action.payload,
        guid: action.guid,
      }
    case SHOW_ERROR_TOAST:
      return {
        ...state,
        type: ToastType.ERROR,
        message: action.payload,
        guid: action.guid,
      }
    case SHOW_WARNING_TOAST:
      return {
        ...state,
        type: ToastType.WARNING,
        message: action.payload,
        guid: action.guid,
      }
    default:
      return state
  }
}
